import React, { useEffect, useState } from 'react';
import { Container, Table, Header } from 'semantic-ui-react';
import { api } from '#/apis';
import Dimmer from '+/Dimmer';

const ViewCounts = props => {

    const [counts, setCounts] = useState(null);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(false);


    useEffect(() => {
        setLoading(true);
        api.get('/counts')
            .then(({ data }) => {
                setCounts(data);
                setLoading(false);
            })
            .catch(err => {
                setErr(true);
            });
    }, []);

    if (err){
        return <Dimmer message='SOMETHING WENT WRONG, PLEASE RELOAD PAGE' />;
    }

    if (loading || !counts) return <Dimmer message='Loading....This may take a while.'/>;


    return (
        <Container fluid className='overflow-x'>
            <Header content='Count Report' subheader='This report updates everyday at 12pm' />
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Property Name' />
                        <Table.HeaderCell content='Occupied Units' />
                        <Table.HeaderCell content='Fulls' />
                        <Table.HeaderCell content='NSF' />
                        <Table.HeaderCell content='Eviction' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {(counts || []).map((property, i) => (
                        <Table.Row key={i}>
                            <Table.Cell content={property.property_name} />
                            <Table.Cell content={property.occupied_units} />
                            <Table.Cell content={property.fulls} />
                            <Table.Cell content={property.nsf} />
                            <Table.Cell content={property.eviction} />
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

        </Container>
    );
};


export default ViewCounts;
